module.exports = __webpack_public_path__ + "static/ms-net-fc43a1e4e7b19245a7c31114bb8b1471.svg";